import React from "react";
import { Box, Toolbar, Typography } from "@mui/material";
import "./styles.scss";
import InvestmentTable from "../../../components/investmentSummaryTable/InvestmentTable";

const InvestmentStatement = () => {
  return (
    <>
      <Toolbar
        sx={{
          justifyContent: "space-between",
          margin: "0px 15px",
        }}
      >
        <Typography className="transactions-history-title">
          Investment Statement Summary
        </Typography>
      </Toolbar>
      <Box sx={{ margin: "20px 40px" }}>
        <InvestmentTable />
      </Box>
    </>
  );
};

export default InvestmentStatement;
